export default "__VITE_ASSET__C0Qrs26w__"